import type { MessageTypeWithStats } from '@owl/shared';
import { type CSSProperties, useEffect, useState } from 'react';
import { BottomSheet } from '../BottomSheet';
import type { MobileShellCtx } from '../MobileShellCtx';

const LABEL: CSSProperties = {
  fontSize: 10.5,
  letterSpacing: '0.16em',
  textTransform: 'uppercase',
  color: 'var(--fg-3)',
  fontWeight: 500,
  marginBottom: 8,
};

export function FilterSheet({ ctx }: { ctx: MobileShellCtx }) {
  const handle = typeof window !== 'undefined' ? window.__mobileFilter : undefined;
  const [selectedIds, setSelectedIds] = useState<string[]>(handle?.filter.messageTypeIds ?? []);
  const [search, setSearch] = useState<string>(handle?.filter.search ?? '');

  useEffect(() => {
    if (!handle) return;
    setSelectedIds(handle.filter.messageTypeIds);
    setSearch(handle.filter.search);
  }, [handle]);

  const apply = () => {
    handle?.setFilter({ messageTypeIds: selectedIds, search });
    ctx.closeSheet();
  };

  const clear = () => {
    setSelectedIds([]);
    setSearch('');
  };

  const toggle = (id: string) =>
    setSelectedIds((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));

  const mts: MessageTypeWithStats[] = handle?.mts ?? [];

  return (
    <BottomSheet title="Filtros" onClose={ctx.closeSheet}>
      <div style={LABEL}>Buscar mensajes</div>
      <input
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        placeholder="palabra clave"
        style={{
          width: '100%',
          background: 'var(--bg-2)',
          border: '1px solid var(--border-1)',
          borderRadius: 10,
          padding: '10px 12px',
          color: 'var(--fg-1)',
          fontSize: 13.5,
          outline: 'none',
          marginBottom: 16,
        }}
      />

      <div style={LABEL}>Tipos de mensaje</div>
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
        {mts.map((m) => {
          const active = selectedIds.includes(m.id);
          return (
            <button
              key={m.id}
              type="button"
              className="chip chip-mt"
              onClick={() => toggle(m.id)}
              style={{
                background: active ? `${m.color}1F` : 'var(--bg-2)',
                borderColor: active ? `${m.color}55` : 'var(--border-2)',
                color: active ? m.color : 'var(--fg-4)',
                cursor: 'pointer',
              }}
            >
              {m.name}
            </button>
          );
        })}
        {mts.length === 0 && <span style={{ fontSize: 12, color: 'var(--fg-4)' }}>Sin tipos</span>}
      </div>

      <div style={{ display: 'flex', gap: 8, marginTop: 20 }}>
        <button
          type="button"
          onClick={clear}
          style={{
            flex: 1,
            padding: 12,
            borderRadius: 10,
            background: 'var(--bg-2)',
            border: '1px solid var(--border-2)',
            color: 'var(--fg-1)',
            fontSize: 13,
          }}
        >
          Limpiar
        </button>
        <button
          type="button"
          onClick={apply}
          style={{
            flex: 1,
            padding: 12,
            borderRadius: 10,
            background: 'var(--accent-dim)',
            border: '1px solid var(--accent-line)',
            color: 'var(--accent)',
            fontSize: 13,
            fontWeight: 500,
          }}
        >
          Aplicar
        </button>
      </div>
    </BottomSheet>
  );
}
